import { get } from 'lodash';

import { SUPPORTED_LOCALES } from 'constants/locales';
import Model from 'models';
import Settings from 'utils/Settings';

const StoryCardV2Model = class extends Model {
  localizedValue(field) {
    return get(
      this._data,
      [field, Settings.currentLocale],
      get(this._data, [field, SUPPORTED_LOCALES.EN_US])
    );
  }

  localizedField(field) {
    return get(field, [Settings.currentLocale], get(field, [SUPPORTED_LOCALES.EN_US]));
  }

  get backgroundColor() {
    return get(this._data, 'backgroundColor');
  }

  get ctaLinks() {
    return get(this._data, 'localizedCtaLinks', []).map(ctaLink => ({
      label: this.localizedField(get(ctaLink, 'localizedLabel')),
      url: this.localizedField(get(ctaLink, 'localizedRelativeUrl')),
      openInNewWindow: this.localizedField(get(ctaLink, 'localizedOpenInNewWindow')),
    }));
  }

  get desktopImage() {
    const localizedFields = get(this.localizedValue('localizedDesktopImage'), 'fields', {});

    return {
      file: this.localizedField(get(localizedFields, 'file')),
      title: this.localizedField(get(localizedFields, 'title')),
      description: this.localizedField(get(localizedFields, 'description')),
    };
  }

  get internalName() {
    return get(this._data, 'internalName');
  }

  get gradientEnabled() {
    return get(this._data, 'gradientEnabled');
  }

  get headerEyebrow() {
    return this.localizedValue('localizedHeaderEyebrow');
  }

  get heading() {
    return this.localizedValue('localizedHeading');
  }

  get mobileImage() {
    const localizedFields = get(this.localizedValue('localizedMobileImage'), 'fields', {});

    return {
      file: this.localizedField(get(localizedFields, 'file')),
      title: this.localizedField(get(localizedFields, 'title')),
      description: this.localizedField(get(localizedFields, 'description')),
    };
  }

  get subheader() {
    return this.localizedValue('localizedSubheader');
  }

  get targeting() {
    return get(this._data, 'targeting');
  }
};

export default StoryCardV2Model;
